const it = {
  common: {
    whatsapp: 'WhatsApp',
    telegram: 'Telegram',
    phone: 'Telefono',
    email: 'Email',
    office: 'Ufficio',
    availability: 'Disponibilità',
    support: 'Supporto',
    preOrder: 'Preordine',
    clearForm: 'Svuota modulo',
    sending: 'Invio in corso...',
    select: 'Seleziona',
    closeNotification: 'Chiudi notifica',
  },
  nav: {
    home: 'Home',
    about: 'Chi siamo',
    preOrder: 'Preordine',
    contacts: 'Contatti',
    startPreOrder: 'Inizia il preordine',
    openMenu: 'Apri menu',
    closeMenu: 'Chiudi menu',
    logoAria: 'Home KUB AUTO',
    languageSwitcher: 'Lingua',
  },
  seo: {
    defaultTitle: 'KUB AUTO — Preordine di veicoli premium in tutta Europa',
    defaultDescription: 'Selezione, verifica, acquisto e consegna di veicoli premium in tutta Europa con condizioni fisse e sicurezza legale.',
    home: {
      title: 'KUB AUTO — Preordine di veicoli premium in tutta Europa',
      description: 'Selezione, verifica, acquisto e consegna di veicoli premium in tutta Europa con condizioni fisse e sicurezza legale.',
    },
    about: {
      title: 'Informazioni su KUB AUTO — servizio di acquisizione di veicoli premium',
      description: 'Scopri come KUB AUTO organizza la ricerca, la verifica, la contrattualizzazione, la logistica e la consegna di veicoli premium in tutta Europa.',
    },
    preOrder: {
      title: 'Modulo di preordine — invia le richieste del veicolo | KUB AUTO',
      description: 'Invia le tue richieste per un veicolo premium e ricevi opzioni verificate, condizioni chiare e un processo basato su contratto.',
    },
    contacts: {
      title: 'Contatti — concierge KUB AUTO',
      description: 'Contatta KUB AUTO via WhatsApp, Telegram o email per consulenze su veicoli premium e richieste di preordine.',
    },
  },
  home: {
    gallery: {
      kicker: 'VEICOLI SELEZIONATI',
      title: 'Auto premium reali da acquisizioni recenti',
      sub: 'Una selezione di veicoli reali che abbiamo recentemente trovato e consegnato. Ogni auto rappresenta i nostri standard di qualità, verifica e servizio.',
    },
    hero: {
      kicker: 'SERVIZIO PRIVATO DI ACQUISIZIONE',
      title: 'Veicoli premium su preordine individuale',
      lead: 'Selezione, verifica, acquisto e consegna in tutta Europa — con condizioni fisse e sicurezza legale.',
      cta: 'Inizia il preordine',
      pills: ['Basato su contratto', 'Banche dati ufficiali', 'Supporto completo'],
      cardTitle: 'Cosa ottieni',
      badge: 'STANDARD',
      bullets: [
        'Processo documentato e costi fissi',
        'Controlli tecnici e legali prima dell’acquisto',
        'Logistica, dogana, certificazione e consegna',
      ],
    },
    process: {
      title: 'Il processo',
      sub: 'Chiaro, documentato, prevedibile.',
      steps: [
        { title: 'Richiesta', sub: 'Requisiti' },
        { title: 'Analisi del mercato', sub: 'Fonti verificate' },
        { title: 'Verifica', sub: 'Legale + tecnica' },
        { title: 'Contratto', sub: 'Condizioni fisse' },
        { title: 'Consegna', sub: 'Ritiro' },
      ],
      ctaTitle: 'Invia le tue richieste — torneremo con opzioni verificate',
      ctaText: 'Il tempo tipico di ricerca va da pochi giorni a due settimane.',
      cta: 'Inizia il preordine',
    },
    trust: {
      title: 'Perché i clienti si fidano di noi',
      sub: 'Trasparenza + sicurezza legale durante l’intera transazione.',
      cards: [
        { title: 'Contratto formale', text: 'Costi, fasi e tempistiche fissati.' },
        { title: 'Verifica', text: 'Banche dati ufficiali + report.' },
        { title: 'Servizio completo', text: 'Logistica, dogana, certificazione.' },
      ],
      missionTitle: 'Procedura regolamentata',
      missionText: 'Selezione → verifica → accordo → contratto → acquisto → consegna → ritiro. Ogni fase è documentata.',
      cta: 'Richiedi una consulenza',
    },
    reviewsFaq: {
      reviewsTitle: 'Note dei clienti',
      reviewsSub: 'Brevi feedback da parte di clienti che apprezzano prevedibilità, chiarezza e controllo.',
      reviews: [
        {
          quote: '“Tutto corrispondeva esattamente a quanto concordato.”',
          text: 'Passaggi chiari, aggiornamenti regolari e nessuna pressione. Prezzo e tempi sono rimasti quelli discussi e la consegna è stata fluida.',
          meta: 'Andrius Kazlauskas, Vilnius (LT)',
        },
        {
          quote: '“Sapevo cosa stava succedendo in ogni fase.”',
          text: 'Hanno inviato opzioni con tutti i dettagli, spiegato cosa controllare e gestito correttamente i documenti. Nessuna chiamata inutile, solo comunicazione chiara.',
          meta: 'Nerijus Šimkus, Kaunas (LT)',
        },
        {
          quote: '“L’auto è arrivata esattamente come descritta.”',
          text: 'I risultati dell’ispezione sono stati condivisi in anticipo, la logistica è stata organizzata senza ritardi e i documenti erano pronti in tempo. Nel complesso — un processo professionale e sereno.',
          meta: 'Mārtiņš Pētersons, Riga (LV)',
        },
      ],
      faqTitle: 'FAQ',
      faqSub: 'Risposte alle domande più comuni sul processo.',
      faq: [
        { q: 'Come avvio un preordine?', a: 'Invia un modulo di preordine con i tuoi requisiti. Confermiamo i dettagli e iniziamo la ricerca.' },
        { q: 'Quanto tempo richiede la ricerca del veicolo?', a: 'Di solito da pochi giorni fino a due settimane, a seconda della complessità delle richieste.' },
        { q: 'Come vengono verificati i veicoli?', a: 'Ogni veicolo viene sottoposto a verifica tecnica e legale tramite banche dati ufficiali e report di ispezione.' },
        { q: 'Quando viene firmato il contratto?', a: 'Dopo che approvi un veicolo specifico e tutte le condizioni sono state concordate.' },
        { q: 'Quali costi vengono fissati in anticipo?', a: 'Il costo del servizio, la logistica, lo sdoganamento e gli oneri obbligatori sono fissati nel contratto.' },
        { q: 'Cosa succede dopo l’acquisto del veicolo?', a: 'Organizziamo logistica, sdoganamento, certificazione e preparazione alla consegna.' },
        { q: 'Quando riceverò il veicolo?', a: 'Dopo il completamento di tutte le procedure e la verifica dei documenti, il veicolo ti viene consegnato.' },
        { q: 'Posso rifiutare un veicolo selezionato?', a: 'Sì. La ricerca continua finché non viene approvato un veicolo che soddisfa pienamente le tue richieste.' },
        { q: 'Lavorate con aziende oltre che con clienti privati?', a: 'Sì. Lavoriamo sia con persone fisiche sia con persone giuridiche tramite contratto formale.' },
        { q: 'In quali paesi cercate i veicoli?', a: 'Cerchiamo veicoli in tutta Europa, lavorando solo con fornitori e piattaforme d’asta verificate.' },
        { q: 'Consegna e sdoganamento sono inclusi?', a: 'Sì. Logistica completa, sdoganamento e certificazione fanno parte del nostro servizio.' },
      ],
    },
    finalCta: {
      kicker: 'PRONTO A INIZIARE',
      title: 'Avvia la tua richiesta di preordine',
      sub: 'Ti risponderemo con opzioni verificate e condizioni chiare.',
      cta: 'Vai al preordine',
    },
  },
  about: {
    hero: {
      kicker: 'SULL’AZIENDA',
      title: 'Veicoli premium acquisiti tramite preordine individuale in tutta Europa',
      lead: 'Forniamo selezione, verifica e acquisizione professionale di veicoli premium in base alle richieste individuali dei clienti, con pieno supporto legale e logistico dalla ricerca iniziale fino alla consegna finale.',
      cta: 'Invia una richiesta di preordine',
    },
    overview: {
      title: 'Panoramica generale',
      sub: 'I nostri servizi sono pensati per clienti che apprezzano trasparenza, processi strutturati e sicurezza legale.',
      cards: [
        {
          title: 'Ambito di attività',
          text: 'L’azienda è specializzata nella ricerca, verifica e acquisto di veicoli premium sul mercato europeo, inclusi concessionari ufficiali, fornitori verificati e piattaforme d’asta. Tutte le fasi — dalla selezione iniziale alla consegna del veicolo — vengono eseguite secondo uno standard qualitativo unificato e tempistiche concordate.',
        },
        {
          title: 'Supporto completo',
          text: 'Offriamo selezione del veicolo in base a parametri definiti, verifica tecnica e legale documentata, definizione dell’ambito e del prezzo nel contratto, organizzazione dell’acquisto, logistica, sdoganamento, certificazione e preparazione del veicolo alla consegna finale.',
        },
      ],
    },
    principles: {
      title: 'Principi di lavoro',
      sub: 'Un processo strutturato e documentato con responsabilità chiare in ogni fase.',
      cards: [
        { icon: '✓', title: 'Formalità e trasparenza', text: 'Tutte le fasi della collaborazione e i costi del servizio sono fissati in un contratto. Il cliente ha piena chiarezza su processo, tempi e obblighi di ciascuna parte.' },
        { icon: '🧾', title: 'Verifica completa del veicolo', text: 'Ogni veicolo viene sottoposto a verifica tecnica e legale tramite banche dati ufficiali, cronologia di manutenzione e, se necessario, ispezione indipendente.' },
        { icon: '🎯', title: 'Approccio individuale', text: 'La selezione del veicolo viene effettuata rigorosamente in base al budget, alle preferenze e all’uso previsto dal cliente — senza offerte casuali o inadatte.' },
        { icon: '🛡', title: 'Supporto totale', text: 'Organizziamo acquisto, logistica, sdoganamento, certificazione e preparazione del veicolo alla consegna, riducendo al minimo rischi e coinvolgimento del cliente.' },
      ],
    },
    advantages: {
      title: 'Vantaggi principali',
      sub: 'Perché i clienti scelgono il formato di preordine individuale con supporto professionale.',
      items: [
        'Competenza comprovata nel segmento automobilistico premium',
        'Collaborazione esclusivamente con fornitori e piattaforme d’asta verificati',
        'Flusso di lavoro chiaramente strutturato e rigoroso rispetto delle tempistiche concordate',
        'Responsabilità per il risultato in ogni fase della transazione',
      ],
    },
    mission: {
      kicker: 'MISSIONE',
      title: 'Fornire accesso a veicoli premium con qualità garantita e sicurezza legale.',
      text: 'Offriamo un servizio strutturato, trasparente e professionale in ogni fase — dalla selezione iniziale fino alla consegna finale del veicolo con documentazione completa.',
      ctaPrimary: 'Invia una richiesta di preordine',
      ctaSecondary: 'Contattaci',
    },
    process: {
      title: 'Come funziona il processo di preordine',
      sub: 'Una procedura sequenziale con fasi definite e punti di controllo.',
      steps: [
        { num: '01', title: 'Richiesta', text: 'Invii i parametri del veicolo e le esigenze individuali.' },
        { num: '02', title: 'Selezione', text: 'Cerchiamo e presentiamo opzioni verificate che corrispondono ai tuoi criteri.' },
        { num: '03', title: 'Contratto', text: 'Tutte le condizioni, le fasi e i costi del servizio vengono fissati contrattualmente.' },
        { num: '04', title: 'Acquisto e logistica', text: 'Organizziamo acquisto, consegna, sdoganamento e certificazione.' },
        { num: '05', title: 'Consegna', text: 'Il veicolo viene preparato e consegnato con un set completo di documenti.' },
      ],
      ctaPrimary: 'Invia una richiesta di preordine',
      ctaSecondary: 'Fai una domanda su Telegram',
    },
  },
  contacts: {
    hero: {
      kicker: 'CONTATTI',
      title: 'Mettiti in contatto',
      lead: 'Il modo più rapido: WhatsApp. Siamo disponibili 24/7 per consulenze e richieste di preordine.',
    },
    primary: {
      title: 'KUB AUTO Concierge',
      emailUs: 'Scrivici',
      telegramCta: 'Preferisci Telegram? Apri la chat →',
    },
    office: {
      label: 'Indirizzo ufficio',
      address: 'Dzūkų g. 6a, Vilnius, 02163 Vilniaus m. sav.',
      badge: '24/7',
      hoursLabel: 'Orari di lavoro',
      hoursValue: '24/7',
      supportLabel: 'Supporto',
      supportValue: 'WhatsApp / Email',
      preOrderLabel: 'Preordine',
      preOrderValue: 'Processo basato su contratto',
      openMaps: 'Apri in Google Maps',
      mapTitle: 'Mappa ufficio KUB AUTO',
    },
    form: {
      title: 'Messaggio rapido',
      sub: 'Lascia una breve nota — risponderemo il prima possibile.',
      nameLabel: 'Il tuo nome',
      namePlaceholder: 'Nome completo',
      emailLabel: 'Email',
      emailPlaceholder: 'name@example.com',
      messageLabel: 'Messaggio',
      messagePlaceholder: 'Che auto stai cercando? Budget, anno, chilometraggio, preferenze...',
      submit: 'Invia messaggio',
      success: 'Messaggio inviato con successo. Ti risponderemo al più presto.',
      error: 'Invio del messaggio non riuscito.',
    },
  },
  preOrder: {
    hero: {
      kicker: 'MODULO DI PREORDINE',
      title: 'Invia i requisiti del veicolo',
      lead: 'Esamineremo la tua richiesta e risponderemo con opzioni verificate e condizioni chiare.',
    },
    vehicle: {
      title: 'Dettagli del veicolo',
      sub: 'Parametri principali per iniziare la selezione.',
      make: 'Marca',
      makePlaceholder: 'es. BMW',
      model: 'Modello',
      modelPlaceholder: 'es. X5',
      year: 'Anno',
      yearPlaceholder: 'es. 2020',
      mileage: 'Chilometraggio (km)',
      mileagePlaceholder: 'es. 45000',
      fuelType: 'Tipo di carburante',
      bodyType: 'Tipo di carrozzeria',
      preferences: 'Preferenze aggiuntive',
      preferencesPlaceholder: 'Allestimento, colore, interni, condizioni, cronologia d’uso, requisiti speciali...',
      fuelOptions: [
        { value: 'petrol', label: 'Benzina' },
        { value: 'diesel', label: 'Diesel' },
        { value: 'hybrid', label: 'Ibrido' },
        { value: 'electric', label: 'Elettrico' },
      ],
      bodyOptions: [
        { value: 'sedan', label: 'Berlina' },
        { value: 'wagon', label: 'Station wagon' },
        { value: 'coupe', label: 'Coupé' },
        { value: 'suv', label: 'SUV' },
        { value: 'hatchback', label: 'Hatchback' },
        { value: 'other', label: 'Altro' },
      ],
    },
    buyer: {
      title: 'Informazioni sull’acquirente',
      sub: 'Per contratto e comunicazione.',
      buyerType: 'Tipo di acquirente',
      buyerTypeOptions: [
        { value: 'individual', label: 'Privato' },
        { value: 'company', label: 'Azienda' },
      ],
      buyerName: 'Nome / Azienda',
      buyerNamePlaceholder: 'Nome completo o entità giuridica',
      address: 'Indirizzo',
      addressPlaceholder: 'Via, città, paese',
      phone: 'Telefono',
      phonePlaceholder: '+370 688 03122',
      email: 'Email',
      emailPlaceholder: 'name@example.com',
      submit: 'Invia richiesta',
      askWhatsapp: 'Chiedi su WhatsApp',
      askTelegram: 'Chiedi su Telegram',
      success: 'Richiesta inviata con successo. Ti contatteremo a breve.',
      error: 'Invio della richiesta non riuscito.',
    },
    validation: {
      required: 'Obbligatorio',
      yearFormat: 'Usa 4 cifre (es. 2020)',
      numbersOnly: 'Solo numeri',
      tooLong: 'Troppo lungo',
      invalidPhone: 'Usa il formato internazionale, es. +37068803122',
      invalidEmail: 'Email non valida',
      invalid: 'Non valido',
    },
  },
  validation: {
    tooShort: 'Troppo corto',
    tooLong: 'Troppo lungo',
    required: 'Obbligatorio',
    invalidEmail: 'Email non valida',
    invalid: 'Non valido',
    unknownError: 'Errore sconosciuto',
  },
};

export default it;
